import {
  LogShadower as LogShadowerDTO,
  ReportingLogDetailsItemDTO,
  ReportingPdCreditEarnedItemDTO,
  ReportingPdSessionAttendanceItemDTO,
  ReportingPdSessionSummaryItemDTO,
} from 'src/app/common/dtos/reports.dto';
import {
  LogShadowerAPIResponse,
  ReportingLogDetailsItemAPIResponse,
  ReportingPdCreditEarnedItemAPIResponse,
  ReportingPdSessionAttendanceItemAPIResponse,
  ReportingPdSessionSummaryItemAPIResponse,
} from '../../types/responses/reporting.responses';

export const logShadowerDTOFromAPIResponse = (
  item: LogShadowerAPIResponse
): LogShadowerDTO => ({
  shadower: item.shadower,
  shadowerPhoto: item.shadower_photo,
  shadowerColor: item.shadower_color,
  shadowerUserId: item.shadower_user_id,
});

export const reportingLogDetailsDTOFromApiResponse = (
  item: ReportingLogDetailsItemAPIResponse
): ReportingLogDetailsItemDTO => ({
  id: item.id,
  title: item.title,
  dateAndTime: item.date_and_time,
  startDatetime: item.start_datetime,
  timezone: item.timezone,
  durationMins: item.duration_mins,
  logType: item.log_type,
  logTypeView: item.log_type_view,
  observationForm: item.observation_form,
  notes: item.notes,
  coachUserId: item.coach_user_id,
  coach: item.coach,
  coachPhoto: item.coach_photo,
  coachColor: item.coach_color,
  attendeeUserId: item.attendee_user_id,
  attendee: item.attendee,
  attendeePhoto: item.attendee_photo,
  attendeeColor: item.attendee_color,
  shadowers: item.shadowers?.map((shadower) =>
    logShadowerDTOFromAPIResponse(shadower)
  ),
  present: item.present,
  absentReason: item.absent_reason,
  school: item.school,
  attendeeDistrict: item.attendee_district,
  coachingSource: item.coaching_source,
  feedback: item.feedback,
  badges: item.badges,
  badgeCount: item.badge_count,
  competencies: item.competencies,
  giCount: item.gi_count,
  todos: item.todos,
});

export const reportingPdCreditEarnedDTOFromApiResponse = (
  item: ReportingPdCreditEarnedItemAPIResponse
): ReportingPdCreditEarnedItemDTO => ({
  userName: item.user_name,
  userId: item.user_id,
  cohorts: item.cohorts,
  sessionCount: item.session_count,
  competencyCount: item.competency_count,
  totalCreditsEarned: item.total_credits_earned,
  creditTypes: item.credit_types,
});

export const reportingPdSessionSummaryDTOFromApiResponse = (
  item: ReportingPdSessionSummaryItemAPIResponse
): ReportingPdSessionSummaryItemDTO => ({
  sessionName: item.session_name,
  pdSessionId: item.pd_session_id,
  sessionDate: item.session_date,
  facilitators: item.facilitators,
  competencies: item.competencies,
  sessionType: item.session_type,
  isCompleted: item.is_completed,
  attendedCount: item.attended_count,
  registeredCount: item.registered_count,
  waitlistCount: item.waitlist_count,
  percentPresent: item.percent_present,
});

export const reportingPdSessionAttendanceDTOFromApiResponse = (
  item: ReportingPdSessionAttendanceItemAPIResponse
): ReportingPdSessionAttendanceItemDTO => ({
  userName: item.user_name,
  userId: item.user_id,
  pdSessionId: item.pd_session_id,
  school: item.school,
  cohorts: item.cohorts,
  status: item.status,
  statusCode: item.status_code,
});
